import {listCallsInProgress, listSessionLogs} from "../../services/apollo/sessions";

export default {
  namespaced: true,

  actions: {
    list({commit}, filters) {
      commit('reset');
      return listSessionLogs(filters)
        .then((sessionLogs) => {
          commit('setSessionLogs', sessionLogs);
          return sessionLogs;
        })
    },

    loadMore({commit}, filters) {
      return listSessionLogs(filters)
        .then((sessionLogs) => {
          commit('setSessionLogs', sessionLogs);
          return sessionLogs;
        })
    },
    listCallsInProgress({commit}) {
      return listCallsInProgress()
        .then((calls) => {
          commit('setCallsInProgress', calls)
        })
    }
  },

  mutations: {
    setSessionLogs(state, sessionLogs) {
      state.list = [...state.list, ...sessionLogs];
      state.map = {
        ...state.map,
        ...sessionLogs.reduce((acc, sessionLog) => ({
          ...acc,
          [sessionLog.id]: sessionLog
        }), {})
      };

    },
    reset(state) {
      state.list = []
    },
    setCallsInProgress(state, calls) {
      state.callsInProgress = calls;
    },
    addCallInProgress(state, call) {
      state.callsInProgress = [...state.callsInProgress, call]
    },
    removeCallInProgress(state, call) {
      state.callsInProgress = state.callsInProgress.filter(c => c.contactId !== call.contactId)
    },
    updateCompositionInfo(state, {id, ...compositionData}) {
      state.list = state.list.map(session => session.id === id
        ? {
          ...session,
          ...compositionData
        }: session)

      state.map = {
        ...state.map,
        [id]: {
          ...state.map[id],
          ...compositionData
        }
      }
    },

    addNote(state, {id, note}) {
      state.list = state.list.map(session => session.id === id
        ? {
          ...session,
          notes: [...session.notes, note]
        }: session)

      state.map = {
        ...state.map,
        [id]: {
          ...state.map[id],
          notes: [...state.map[id].notes, note]
        }
      }
    },

    updateNote(state, {id, note}) {
      state.list = state.list.map(session => session.id === id
        ? {
          ...session,
          notes: [note]
        }: session);

      state.map = {
        ...state.map,
        [id]: {
          ...state.map[id],
          notes: [note]
        }
      }
    },

    removeNote(state, {id, noteId}) {
      state.list = state.list.map(session => session.id === id
        ? {
          ...session,
          notes: session.notes.filter(note => note.id !== noteId)
        }: session);

      state.map = {
        ...state.map,
        [id]: {
          ...state.map[id],
          notes: state.map[id].notes.filter(note => note.id !== noteId)
        }
      }
    },

    deleteScreenshot(state, {id, sessionId}) {
      try {
        state.list = state.list.map(session => session.id === sessionId
          ? {
            ...session,
            screenshots: session.screenshots.filter(screenshot => screenshot.id !== id)
          }: session);

        state.map = {
          ...state.map,
          [sessionId]: {
            ...state.map[sessionId],
            screenshots: state.map[sessionId].screenshots.filter(screenshot => screenshot.id !== id)
          }
        }
      } catch (e) {

      }
    },


  },

  getters: {
    isContactInCall: (state) => (contactId) => !!state.callsInProgress.find(call => call.contactId === contactId)
  },


  state: {
    list: [],
    callsInProgress: [],
    map: {}
  }
}
